/**
 * Abstraction for date-fns
 */
import {addDays as add, format, isFuture, isToday, subDays, differenceInMonths, parseISO} from 'date-fns';

export const formatDate = (date: Date, pattern: string = 'dd MM yyyy') => {
    return format(date, pattern);
}

export const parseDateString = (date: string): Date => {
    return parseISO(date)
}

export const subtractDays = (date: Date, amount: number): Date => {
    return subDays(date, amount);
}

export const addDays = (date: Date, amount: number): Date => {
    return add(date, amount);
}

export const isDateSearchable = (date: Date): boolean => {
    return isFuture(date) === false && isToday(date) === false;
}

export const isDateExpired = (date: Date): boolean => {
    return differenceInMonths(new Date(), date) > 3;
}

